import React, { useState, useCallback } from 'react';
import { Filters } from 'types/clientList';
import { Filters as FiltersWrap } from 'widgets';
import StatusSelect from './StatusSelect';

const FILTER_TO_NAMES = {
  status: 'Статус',
};

type Props = {
  onConfirm: (filters: Object) => void;
  onSearch?: (search: string) => void;
  filters: Filters;
};

const TableFilters: React.FC<Props> = ({
  onConfirm,
  filters: initialFilters,
}) => {
  const [filters, setFilters] = useState<Filters>(initialFilters);

  const handleChange = useCallback((filterType, value) => {
    setFilters((prev) => ({ ...prev, [filterType]: value }));
  }, []);

  const handleSearch = useCallback(
    (search: string) => {
      setFilters((prev) => {
        const newFilters = { ...prev, search };
        onConfirm(newFilters);
        return newFilters;
      });
    },
    [onConfirm]
  );

  const handleConfirm = () => {
    onConfirm(filters!);
  };

  const handleDelete = (key: string) => {
    const { [key as keyof Filters]: _, ...newFilters } = filters;
    setFilters(newFilters);
    onConfirm(newFilters);
  };

  const handleReset = () => {
    setFilters({});
    onConfirm({});
  };

  const activeFilters = Object.keys(filters)
    .filter((x) => filters[x])
    .filter((x) => x !== 'search')
    .map((key) => ({ key, name: FILTER_TO_NAMES[key] }));

  const isEnabled = Boolean(activeFilters.length);

  return (
    <FiltersWrap
      isEnabled={isEnabled}
      activeFilters={activeFilters}
      onConfirm={handleConfirm}
      onSearch={handleSearch}
      onReset={handleReset}
      onDeleteOne={handleDelete}
      searchLabel="Поиск по названию"
      searchValue={filters['search']}
    >
      <form>
        <StatusSelect
          value={filters.status}
          onChange={(_, value) => handleChange('status', value)}
        />
        <div />
      </form>
    </FiltersWrap>
  );
};

export default TableFilters;
